import { Record, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';

import { resourceStoreTypes } from '../core';

export const TERMS_REDUCER_KEY = 'termsStore';
export type TermsStore = QcsSyncResourceStore<TermProps>;
export const mkTermsStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<TermProps>();

export type TermProps = {
  id?: string;
  clientId?: string;
  userModifiedAt?: string;
  createdAt?: string;
  modifiedAt?: string;
  name?: string;
  days?: number;
  isDeleted?: boolean;
  isArchived?: boolean;
};

export type Term = RecordOf<TermProps>;

export const mkTerm = Record<TermProps>({
  id: undefined,
  clientId: undefined,
  userModifiedAt: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  name: undefined,
  days: undefined,
  isDeleted: undefined,
  isArchived: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [TERMS_REDUCER_KEY]: QcsSyncResourceStore<TermProps>;
  }
}
